<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Delete {{ field }}?</modal-header>
        </div>
        Are you want to delete this client and all their creative?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, delete"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {clientMixin} from '@/mixins/clientMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {modalMixin} from '@/mixins/modalMixin'

export default {
  name: 'modal_client_confirm',
  mixins: [clientMixin, notificationMixin, modalMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.deleteClient(this.confirmId).then(() => {
        this.getClients().then(() => {
          this.finishLoading()
          this.addNotification('success', `Client deleted.`)
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/clients/modal-client-confirm.vue